import { __awaiter, __generator } from "tslib";
export var PaymentCycleType;
(function (PaymentCycleType) {
    PaymentCycleType[PaymentCycleType["ONE_TIME"] = 0] = "ONE_TIME";
    PaymentCycleType[PaymentCycleType["DAILY"] = 1] = "DAILY";
    PaymentCycleType[PaymentCycleType["WEEKLY"] = 2] = "WEEKLY";
    PaymentCycleType[PaymentCycleType["MONTHLY"] = 3] = "MONTHLY";
    PaymentCycleType[PaymentCycleType["QUARTERLY"] = 4] = "QUARTERLY";
    PaymentCycleType[PaymentCycleType["SEMI_ANNUALLY"] = 5] = "SEMI_ANNUALLY";
    PaymentCycleType[PaymentCycleType["YEARLY"] = 6] = "YEARLY";
    PaymentCycleType[PaymentCycleType["TWO_YEARS"] = 7] = "TWO_YEARS";
    PaymentCycleType[PaymentCycleType["THREE_YEARS"] = 8] = "THREE_YEARS";
})(PaymentCycleType || (PaymentCycleType = {}));
;
export var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum[ProductTypeEnum["KNOWLEDGE_BASE"] = 1] = "KNOWLEDGE_BASE";
    ProductTypeEnum[ProductTypeEnum["TICKETS"] = 2] = "TICKETS";
    ProductTypeEnum[ProductTypeEnum["CALL_CENTER"] = 3] = "CALL_CENTER";
    ProductTypeEnum[ProductTypeEnum["CHAT"] = 4] = "CHAT";
    ProductTypeEnum[ProductTypeEnum["COMBO"] = 10] = "COMBO";
})(ProductTypeEnum || (ProductTypeEnum = {}));
;
export var PaymentCycleOptions;
(function (PaymentCycleOptions) {
    PaymentCycleOptions["MONTHLY"] = "MONTHLY";
    PaymentCycleOptions["YEARLY"] = "YEARLY";
    PaymentCycleOptions["TWO_YEARS"] = "TWO_YEARS";
})(PaymentCycleOptions || (PaymentCycleOptions = {}));
;
;
;
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["POSTED"] = "Posted";
    InvoiceStatus["DRAFT"] = "Draft";
    InvoiceStatus["CANCELED"] = "Canceled";
    InvoiceStatus["ERROR"] = "Error";
})(InvoiceStatus || (InvoiceStatus = {}));
;
;
;
export var BillingServiceProvider;
(function (BillingServiceProvider) {
    BillingServiceProvider[BillingServiceProvider["SBS"] = 1] = "SBS";
    BillingServiceProvider[BillingServiceProvider["ZUORA"] = 2] = "ZUORA";
})(BillingServiceProvider || (BillingServiceProvider = {}));
export var createAccountApi = function (baseUrl, http) {
    var accountsBase = baseUrl + "/accounts";
    var billingBase = baseUrl + "/billing";
    var api = {
        purchaseUrl: billingBase + "/purchase",
        extendSession: function (sameSite) {
            return http.post(accountsBase + "/extend-session", sameSite ? { sameSite: true } : {}); // temp solution for
        },
        getPurchaseData: function (data) {
            return http.post(billingBase + "/purchase", data);
        },
        getCallCenterCreditBalance: function () {
            return http.get(billingBase + "/callcenter/balance");
        },
        getCallCenterCreditPurchaseData: function (data) {
            return http.post(billingBase + "/purchase/callcenter", data);
        },
        getPricingPlans: function () {
            return http.get("https://www.wixanswers.com/api/pricing-plans");
        },
        getPlan: function (_) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {}];
            });
        }); },
        pingRealTime: function () {
            return http.post(accountsBase + "/realtime/ping", {});
        },
        getZuoraIframe: function (debug) {
            if (debug) {
                return http.get(billingBase + "/iframe?debug=" + debug);
            }
            return http.get(billingBase + "/iframe");
        },
        confirmZuoraOrder: function (dto) {
            return http.post(billingBase + "/order", dto);
        },
        previewZuoraOrder: function (dto) {
            return http.post(billingBase + "/order/preview", dto);
        },
        purchaseCallCredits: function (dto) {
            return http.post(billingBase + "/order/callCredits", dto);
        },
        getBillingProvider: function () {
            return http.get(billingBase + "/provider");
        },
        getUserCountryCode: function () {
            var headers = { Accept: 'text/plain' };
            return http.get(baseUrl + "/users/me/geo/country", headers);
        },
        isNameAvailable: function (name) {
            return http.post(baseUrl + "/tenants/nameAvailable", { name: name });
        },
        getLatestInvoicesDetails: function () {
            return http.get(billingBase + "/invoices");
        },
        downloadInvoice: function (invoiceId) {
            return billingBase + "/invoices/" + invoiceId + "/download";
        },
        getDefaultPaymentMethod: function () {
            return http.get(billingBase + "/paymentMethods/default");
        },
        replaceDefaultPaymentMethod: function (dto) {
            return http.post(billingBase + "/creditCards/replace", dto);
        }
    };
    return api;
};
//# sourceMappingURL=index.js.map